import { AiProcessingValue } from '@g17eco/types/ai';

export const allowAIProcessing = ({ aiProcessing }: { aiProcessing?: AiProcessingValue }) => {
  // Treat undefined as 'include' (opt-in behavior)
  return aiProcessing !== AiProcessingValue.Exclude;
};
